// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_re5","cls2":"FilterPanel-cls2_GTz FilterPanel-cls1_re5"};